import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useAriaAnnouncer from './useAriaAnnouncer';

var AriaAnnounce = function AriaAnnounce(_ref) {
  var announcement = _ref.announcement;

  var _useAriaAnnouncer = useAriaAnnouncer(),
      announce = _useAriaAnnouncer.announce;

  useEffect(function () {
    if (announcement) {
      announce(announcement);
    }
  }, [announce, announcement]); // If we return null here, react-docgen wouldn't be able to locate the component

  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

AriaAnnounce.propTypes = {
  /**
   * String which will be announced by screen readers on change
   */
  announcement: PropTypes.string
};
export default AriaAnnounce;